import { render, staticRenderFns } from "./EditionModal.vue?vue&type=template&id=12ebd978&scoped=true"
import script from "./EditionModal.vue?vue&type=script&lang=js"
export * from "./EditionModal.vue?vue&type=script&lang=js"
import style0 from "./EditionModal.vue?vue&type=style&index=0&id=12ebd978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ebd978",
  null
  
)

export default component.exports